// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__t5Viq","header":"styles_header__Kot8l","btn":"styles_btn__1vw1c"};